import React from 'react';
import { Drawer, Badge, Button } from '@/components/ui';
import type { MaintenanceSchedule } from '../types/maintenance-schedules.types';

export interface ScheduleDetailDrawerProps {
  schedule: MaintenanceSchedule | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ScheduleDetailDrawer({ schedule, isOpen, onClose }: ScheduleDetailDrawerProps) {
  if (!schedule) return null;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title={`Chi tiết lịch bảo dưỡng`}
      size="md"
    >
      <div className="p-6 space-y-6">
        {schedule.conflict_issues && schedule.conflict_issues.length > 0 && (
          <div className="bg-red-50 text-red-700 p-3 rounded-lg border border-red-200 text-sm flex items-start gap-2">
            <i className="ri-error-warning-line mt-0.5"></i>
            <div>
              <div className="font-semibold mb-1">Cảnh báo xung đột</div>
              <ul className="list-disc list-inside">
                {schedule.conflict_issues.map((issue, idx) => (
                  <li key={idx}>{issue}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="flex items-center gap-4">
          <Badge variant={
            schedule.status === 'completed' ? 'success' :
              schedule.status === 'delayed' ? 'danger' :
                schedule.status === 'assigned' ? 'info' : 'neutral'
          }>
            {schedule.status}
          </Badge>
          {schedule.work_order_id && (
            <span className="text-sm font-mono text-brand-600 bg-brand-50 px-2 py-1 rounded border border-brand-200">
              {schedule.work_order_id}
            </span>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-os-muted ">Khu vực</div>
            <div className="font-semibold text-os-text">{schedule.zone_name}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Loại công việc</div>
            <div className="font-semibold text-os-text capitalize">{schedule.task_type}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Ngày thực hiện</div>
            <div className="font-semibold text-os-text">{new Date(schedule.scheduled_date).toLocaleDateString('vi-VN')}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Thời gian</div>
            <div className="font-semibold text-os-text">
              {schedule.start_time && schedule.end_time ? `${schedule.start_time} - ${schedule.end_time}` : 'Cả ngày'}
            </div>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-4">
          <div className="text-xs text-os-muted  mb-2">Tổ đội phụ trách</div>
          <div className="bg-slate-50 p-4 rounded-lg border border-slate-100 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center">
                <i className="ri-team-line text-lg"></i>
              </div>
              <div>
                <div className="font-semibold text-os-text">{schedule.team_name || 'Chưa gán tổ đội'}</div>
                <div className="text-xs text-os-muted">Click để thay đổi tổ đội</div>
              </div>
            </div>
            <Button variant="outline" size="sm">Đổi tổ</Button>
          </div>
        </div>

        {!schedule.work_order_id && (
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 flex items-center justify-between">
            <div className="text-sm text-blue-800">
              Lịch này chưa có Work Order để thực thi.
            </div>
            <Button variant="primary" size="sm">Tạo WO ngay</Button>
          </div>
        )}
      </div>
    </Drawer>
  );
}
